import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    body {
        font-family: 'Inter', sans-serif;
        margin: 0;
    }
`;

export default GlobalStyle;
